/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-22 16:00:18
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-13 14:01:56
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/slice/reduxCommonFunctions.ts
 * @LastEditTime: 2021-03-24 15:49:53
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/slice/reduxCommonFunctions.ts
 */
import {
  hasError,
  assData,
  defaultStatus,
  generateDefaultState,
  onCollapseOpen,
} from 'src/constrains/SalesChannelPreviewPageComponents/tools';
import {
  request_hideProduct,
  request_showProduct,
  request_deleteProduct,
} from 'src/request/salesChannel/product';
import { createAsyncThunk } from '@reduxjs/toolkit';

const hideProduct = createAsyncThunk(
  'salesChannelHideProduct',
  async (uuid: any) => {
    const response = await request_hideProduct(uuid);
    return response;
  },
);

const displayProduct = createAsyncThunk(
  'salesChannelDisplayProduct',
  async (uuid: any) => {
    const response = await request_showProduct(uuid);
    return response;
  },
);

const deleteProduct = createAsyncThunk(
  'salesChannelDeleteProduct',
  async (uuid: any) => {
    const response = await request_deleteProduct(uuid);
    return response;
  },
);

const changeProductVisibility = (state, visible) => {
  if (state.salesChannelProduct) {
    state.salesChannelProduct.visible = visible;
  } else {
    state.salesChannelProduct = { visible };
  }
};

export {
  hasError,
  assData,
  defaultStatus,
  generateDefaultState,
  onCollapseOpen,
  hideProduct,
  deleteProduct,
  displayProduct,
  changeProductVisibility,
};
